// extracted by mini-css-extract-plugin
export default {"searchbar":"style_searchbar__0TwnG","ViewButton":"style_ViewButton__8hbkt"};